export default __webpack_public_path__ + "static/media/icn-add-small-blue.1c170812.svg";